(function () {
    window.addEventListener('DOMContentLoaded', function () {
        const script = document.createElement('script');
        script.src = '//widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js';
        script.defer = true;
        document.body.appendChild(script);
    });
})();
